var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
import { Dialog, DialogActions, DialogContent, DialogTitle, Accordion, AccordionDetails, AccordionSummary, IconButton, makeStyles, Menu, MenuItem, styled, Toolbar as ToolbarBase } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SortIcon from '@material-ui/icons/Sort';
import { Alert, AlertTitle, TreeView } from '@material-ui/lab';
import TreeItem from '@material-ui/lab/TreeItem';
import { useIO, useLinked } from '@type-r/react';
import * as React from 'react';
import { jumpToAnchor, span } from '../common';
import { Loading } from '../flex';
import { Button, PrimaryButton } from './buttons';
import { ReadOnly } from './inputs';
import { LqxTitle, useQaId } from './qa-ids';
export var Columns = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
});
export var Toolbar = styled(ToolbarBase)({
    paddingTop: 4,
    paddingBottom: 4,
    minHeight: '32px',
    backgroundColor: 'white'
});
export var AdvancedSearchBar = styled('div')({
    paddingTop: 4,
    paddingBottom: 4,
    textAlign: 'center'
});
/**
 * Select the sort field name and the sort order
 */
export var SelectSortBy = styled(function (_a) {
    var className = _a.className, options = _a.options, $attr = _a.$attr, $asc = _a.$asc;
    var $menuAnchor = useLinked(null);
    return React.createElement(React.Fragment, null,
        React.createElement("span", { className: className, onClick: function (e) { return $menuAnchor.set(e.currentTarget); } },
            "Sort By: ",
            React.createElement("u", null, options[$attr.value])),
        React.createElement(Menu, { getContentAnchorEl: null, anchorEl: $menuAnchor.value, open: Boolean($menuAnchor.value), onClose: $menuAnchor.null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            } }, Object.keys(options).map(function (attr) {
            return React.createElement(MenuItem, { key: attr, onClick: function () {
                    $menuAnchor.null();
                    $attr.set(attr);
                } }, options[attr]);
        })),
        React.createElement(IconButton, { "aria-label": "Sort By", size: "small", onClick: function () { return $asc.update(toggle); } },
            $asc.value ? '↑' : '↓',
            " ",
            React.createElement(SortIcon, null)));
})({
    color: '#728A97',
    fontFamily: 'Montserrat',
    fontSize: 14,
    whiteSpace: 'nowrap',
    fontWeight: 500,
    alignSelf: 'center',
    letterSpacing: 'NaNpx',
    textAlign: 'center',
    cursor: 'pointer'
});
var toggle = function (x) { return !x; };
export var Column = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginRight: '1em',
    marginLeft: '1em'
});
export var TopSection = function (_a) {
    var id = _a.id, title = _a.title, children = _a.children, lqxId = _a["qa-id"];
    var classes = CollapsableSection.useStyles();
    var nextId = useQaId(lqxId || title);
    return (React.createElement(LqxTitle, { value: nextId },
        React.createElement("div", { id: id, "data-qa-id": nextId, className: classes.superSection },
            React.createElement("div", { className: classes.superSectionTitle }, title),
            React.createElement("div", null, children))));
};
/**
 * Main grouping block of the form layout.
 * (?) To be renamed to FieldSet (?)
 */
export var CollapsableSection = function (_a) {
    var id = _a.id, title = _a.title, info = _a.info, right = _a.right, noMargins = _a.noMargins, lqxId = _a["qa-id"], notExpanded = _a.notExpanded, titleClassName = _a.titleClassName, noBorder = _a.noBorder, noShadow = _a.noShadow, noTitleIndentation = _a.noTitleIndentation, children = _a.children;
    var classes = CollapsableSection.useStyles();
    var nextId = useQaId(lqxId || title);
    return (React.createElement(LqxTitle, { value: nextId },
        React.createElement(Accordion, { defaultExpanded: !notExpanded, id: id, "data-qa-id": nextId, elevation: noShadow && 0, className: noBorder && classes.hideBorder },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), className: noTitleIndentation && classes.noTitleIndentation },
                React.createElement("span", { className: titleClassName ? titleClassName : classes.sectionTitle }, title),
                React.createElement("span", { className: classes.title }, info || ""),
                right && React.createElement("span", { className: classes.right }, right)),
            React.createElement(AccordionDetails, { classes: { root: noMargins ? classes.noMargins : classes.root } }, children))));
};
export var SectionTitle = span({
    color: '#052C4C',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
    marginRight: '1em',
    display: 'flex',
    alignItems: 'center'
});
CollapsableSection.useStyles = makeStyles({
    root: {
        //flexWrap: 'wrap',
        flexDirection: 'column',
        wordWrap: 'break-word'
    },
    noMargins: {
        flexWrap: 'wrap',
        flexDirection: 'column',
        paddingLeft: 0,
        paddingRight: 0,
    },
    right: {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    superSectionTitle: {
        color: '#052C4C',
        fontSize: 18,
        fontWeight: 500,
        marginBottom: 10
    },
    superSection: {
        marginBottom: 10,
        marginTop: 10
    },
    sectionTitle: {
        color: '#052C4C',
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'uppercase',
        marginRight: '1em',
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        color: '#052C4C',
        fontSize: 14,
        display: "flex",
        alignItems: "center"
    },
    subsection: {
        //minWidth : '100%',
        marginTop: 4,
        marginBottom: 4
    },
    subsectionTitle: {
        color: '#668AA5',
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'uppercase',
        marginBottom: 16
    },
    noTitleIndentation: {
        padding: 0
    },
    hideBorder: {
        '&.MuiAccordion-root:before': {
            display: 'none',
        },
    }
});
export var Section = function (_a) {
    var id = _a.id, title = _a.title, children = _a.children, lqxId = _a["qa-id"];
    var classes = CollapsableSection.useStyles();
    var nextId = useQaId(lqxId || title);
    return (React.createElement(LqxTitle, { value: nextId },
        React.createElement("div", { id: id, className: classes.superSection, "data-qa-id": nextId },
            React.createElement(SectionTitle, null, title),
            React.createElement("div", null, children))));
};
export var Subsection = function (_a) {
    var id = _a.id, title = _a.title, children = _a.children, lqxId = _a["qa-id"];
    var classes = CollapsableSection.useStyles();
    var nextId = useQaId(lqxId || title);
    return (React.createElement(LqxTitle, { value: nextId },
        React.createElement("div", { id: id, className: classes.subsection, "data-qa-id": nextId },
            React.createElement("div", { className: classes.subsectionTitle }, title),
            React.createElement("div", null, children))));
};
/**
 * Navigation tree menue.
 */
export var NavTree = function (_a) {
    var children = _a.children, defaultExpanded = _a.defaultExpanded;
    var _b = React.useState(defaultExpanded), expanded = _b[0], setExpanded = _b[1];
    var handleToggle = function (event, nodeIds) {
        if (event.target.closest(".MuiTreeItem-iconContainer")) {
            setExpanded(nodeIds);
        }
    };
    return (React.createElement(TreeView, { defaultCollapseIcon: React.createElement(ExpandMoreIcon, null), defaultExpandIcon: React.createElement(ChevronRightIcon, null), expanded: expanded, onNodeToggle: handleToggle }, children));
};
var navTreeItemFontStyle = makeStyles({
    label: {
        fontSize: 16
    }
});
export var NavTreeItem = function (_a) {
    var target = _a.target, label = _a.label, children = _a.children, rest = __rest(_a, ["target", "label", "children"]);
    var classes = navTreeItemFontStyle(rest);
    return (React.createElement(TreeItem, { classes: classes, nodeId: target, label: label, onClick: function () { return jumpToAnchor(target); } }, children));
};
export var PopupDialog = function (_a) {
    var title = _a.title, children = _a.children, actions = _a.actions, _b = _a.hideTitle, hideTitle = _b === void 0 ? false : _b, rest = __rest(_a, ["title", "children", "actions", "hideTitle"]);
    return React.createElement(Dialog, __assign({ PaperProps: { "aria-label": "" + title }, open: true, fullWidth: true }, rest),
        hideTitle ? undefined : (React.createElement(DialogTitle, null,
            React.createElement(SectionTitle, null, title))),
        React.createElement(DialogContent, null,
            React.createElement(ReadOnly.Provider, { value: false }, children)),
        React.createElement(DialogActions, null, actions));
};
//<ReadOnly.Provide value={false}>
export var PopupIODialog = function (_a) {
    var title = _a.title, width = _a.width, formatError = _a.formatError, actionLabel = _a.actionLabel, success = _a.success, $isOpen = _a.$isOpen, doIO = _a.doIO, children = _a.children, disabled = _a.disabled, hideTitleOnSuccess = _a.hideTitleOnSuccess, onSuccess = _a.onSuccess, classes = _a.classes, maxWidth = _a.maxWidth, altActionLabel = _a.altActionLabel, altDoIO = _a.altDoIO;
    var $doIO = useLinked(null);
    var isReady = useIO(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!($doIO.value === 'primary')) return [3 /*break*/, 2];
                    return [4 /*yield*/, doIO()];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    if (!($doIO.value === 'alt')) return [3 /*break*/, 5];
                    _a = altDoIO;
                    if (!_a) return [3 /*break*/, 4];
                    return [4 /*yield*/, altDoIO()];
                case 3:
                    _a = (_b.sent());
                    _b.label = 4;
                case 4: return [2 /*return*/, _a];
                case 5: return [2 /*return*/, false];
            }
        });
    }); }, [$doIO.value]);
    var _b = React.useState(false), hideTitle = _b[0], setHideTitle = _b[1];
    React.useEffect(function () {
        if (hideTitleOnSuccess && $doIO.isTruthy && isReady) {
            setHideTitle(true);
        }
    }, [$doIO.value, isReady['_changeToken']]);
    var error = isReady && typeof isReady === 'object' ? isReady : null;
    return (React.createElement(PopupDialog, { title: title, width: width, actions: $doIO.isTruthy ?
            React.createElement(PrimaryButton, { disabled: !isReady, onClick: function () {
                    onSuccess && onSuccess();
                    $isOpen.false();
                } }, "Close")
            :
                React.createElement(React.Fragment, null,
                    React.createElement(Button, { onClick: $isOpen.false }, "Cancel"),
                    altActionLabel &&
                        React.createElement(Button, { "qa-id": 'alt-action', disabled: disabled, onClick: function () { return $doIO.set('alt'); } }, altActionLabel),
                    React.createElement(PrimaryButton, { disabled: disabled, onClick: function () { return $doIO.set('primary'); } }, actionLabel)), onClose: $isOpen.false, hideTitle: hideTitle, classes: classes, maxWidth: maxWidth }, isReady ? (error ?
        React.createElement(Alert, { severity: "error" },
            React.createElement(AlertTitle, null, "Error"),
            formatError ? formatError(error) : error.message)
        :
            $doIO.isTruthy ?
                success :
                children) :
        React.createElement(Loading, null)));
};
//# sourceMappingURL=layout.js.map